import { useState } from "react";
import SaleRecordConfirmPopup from "../confirm/window-confirm-dialog";

export const useConfirmDialog = () => {
  const [confirmPopup, setConfirmPopup] = useState<{
    show: boolean;
    title: string;
    message: string;
    onConfirm: () => void;
    onCancel: () => void;
  }>({
    show: false,
    title: "",
    message: "",
    onConfirm: () => {},
    onCancel: () => {},
  });

  const showConfirmDialog = (title: string, message: string): Promise<boolean> => {
    return new Promise((resolve) => {
      setConfirmPopup({
        show: true,
        title,
        message,
        onConfirm: () => {
          setConfirmPopup((prev) => ({ ...prev, show: false }));
          resolve(true);
        },
        onCancel: () => {
          setConfirmPopup((prev) => ({ ...prev, show: false }));
          resolve(false);
        },
      });
    });
  };

  const ConfirmDialogComponent = () => (
    <>
      {confirmPopup.show && (
        <SaleRecordConfirmPopup
          title={confirmPopup.title}
          message={confirmPopup.message}
          modalClosed={confirmPopup.onCancel}
          modalSubmit={confirmPopup.onConfirm}
          isLoading={false}
        />
      )}
    </>
  );

  return { showConfirmDialog, ConfirmDialogComponent };
};
